import React from "react";

function ResumeItem({ resumeData }) {
  const { year, position, company, details } = resumeData;
  return (
    <div className="mi-resume">
      <div className="mi-resume-header">
        <span className="mi-resume-year">{year}</span>
        <span className="mi-resume-sep">—</span>
        <h5 className="mi-resume-title">{position}</h5>
        {company && <span className="mi-resume-company">({company})</span>}
      </div>
      {details && (
        <div className="mi-resume-details">
          <p>{details}</p>
        </div>
      )}
    </div>
  );
}

export default ResumeItem;
